// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

const icon = (name) => <Iconify icon={name} sx={{ width: 1, height: 1 }} />;

const navConfigAuth = [
  // AUTHENTICATED USER MENU
  // ----------------------------------------------------------------------
  {
    subheader: '',
    items: [
      { 
        title: 'Search Companies', 
        path: PATH_DASHBOARD.dashboard,
        icon: icon('eva:search-fill'),
      },
      { 
        title: 'API', 
        path: 'https://api.rivadata.com',
        icon: icon('eva:code-fill'),
      },
    ],
  },
];

export default navConfigAuth;